import { postupConstants } from '../constants/postupConstants'
import { postupService } from '../../services/API/postupService'

export const addPostup = (postData, url) => {
  return dispatch => {
    postupService.addPostup(postData, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function request(data) {
    return { type: postupConstants.POSTUP_REQUEST, data }
  }
  function success(data) {
    return { type: postupConstants.POSTUP_SUCCESS, data }
  }
  function failure(error) {
    return { type: postupConstants.POSTUP_FAILURE, error }
  }
}

export const editPostup = (postData, url) => {
  return dispatch => {
    postupService.editPostup(postData, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function request(data) {
    return { type: postupConstants.POSTUP_REQUEST, data }
  }
  function success(data) {
    return { type: postupConstants.POSTUP_SUCCESS, data }
  }
  function failure(error) {
    return { type: postupConstants.POSTUP_FAILURE, error }
  }
}

export const getPostupDetail = (id, url) => {
  return dispatch => {
    postupService.getPostupDetail(id, url).then(
      data => {
        dispatch(success(data))
      },

      error => {
        dispatch(failure(error.toString()))
      }
    )
  }

  function request(data) {
    return { type: postupConstants.GET_POSTUP_REQUEST, data }
  }
  function success(data) {
    return { type: postupConstants.GET_POSTUP_SUCCESS, data }
  }
  function failure(error) {
    return { type: postupConstants.GET_POSTUP_FAILURE, error }
  }
}

export const listPostup = (postData, url) => {
  return dispatch => {
    postupService.listPostup(postData, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function request(data) {
    return { type: postupConstants.LIST_POSTUP_REQUEST, data }
  }
  function success(data) {
    return { type: postupConstants.LIST_POSTUP_SUCCESS, data }
  }
  function failure(error) {
    return { type: postupConstants.LIST_POSTUP_FAILURE, error }
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/actions/postupActions.js